import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LinkedinLogo, ArrowUpRight } from "@phosphor-icons/react";
import { COMPANY } from "@/data/content";

export default function NewsletterSection() {
  return (
    <section
      data-testid="newsletter-section"
      className="relative bg-slate-50 py-20 md:py-28 border-y border-slate-200"
    >
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <div className="overline mb-4 inline-flex items-center gap-2">
            <LinkedinLogo size={14} weight="fill" /> LinkedIn Newsletter
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
            Field notes on cyber, AI & immersive tech — straight to your inbox.
          </h2>
          <p className="mt-6 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">
            Subscribe to the official <span className="text-slate-900 font-semibold">Theta Dynamics</span> LinkedIn newsletter — short, high-signal essays on cybersecurity, AI engineering, ERP delivery and immersive product design from the team building it.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="md:col-span-5"
        >
          <a
            href={COMPANY.social.newsletter}
            target="_blank"
            rel="noreferrer"
            data-testid="newsletter-cta"
            className="card-flat block p-7 md:p-9 group"
          >
            <div className="flex items-center justify-between">
              <LinkedinLogo size={36} weight="fill" className="text-[#1D4ED8]" />
              <ArrowUpRight size={20} weight="bold" className="text-slate-400 group-hover:text-[#1D4ED8] transition-colors" />
            </div>
            <div className="mt-8 font-display text-xl md:text-2xl font-semibold text-slate-900 tracking-tight">
              Subscribe on LinkedIn
            </div>
            <p className="mt-2 text-sm text-slate-500">
              Monthly · No spam · Unsubscribe anytime.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase text-[#1D4ED8]">
              Open newsletter
            </div>
          </a>

          <Link
            to="/contact"
            data-testid="newsletter-secondary-cta"
            className="mt-3 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.22em] uppercase text-slate-700 hover:text-[#1D4ED8] transition-colors"
          >
            Or talk to our team <ArrowUpRight size={12} weight="bold" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
